import React, {useEffect, useState} from 'react';
import {RoundedButton, RoundedButtonWrapper, Loader} from './styles';
import {Values} from '@src/Tools/Values';

interface IActivationButtonProps {
    isActive: boolean;
    onActivationButtonClick: () => void;
}

const AppActivationButton = ({ isActive, onActivationButtonClick }: IActivationButtonProps) => {
    const [buttonName, setButtonName] = useState<JSX.Element | string>("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const localizationKey = isActive ? 'deactivateApplication' : 'activateApplication';

        setIsLoading(false);
        setButtonName(Values.getLocalizationValue(localizationKey));
    }, [isActive]);

    const onClick = () => {
        setIsLoading(true);
        setButtonName(<Loader/>);
        onActivationButtonClick();
    };

    return (
        <RoundedButtonWrapper>
            <RoundedButton
                onClick={onClick}
                isActive={isActive}
                isLoading={isLoading}
            >
                {buttonName}
            </RoundedButton>
        </RoundedButtonWrapper>
    )
}

export default AppActivationButton;
